import styled from "styled-components";

export const FooterWrapper = styled.footer`
  background-image: linear-gradient(to right, #5965ab, #2f365e);
`;
